import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../../data/site";

export const Testimonials = () => (
  <section
    id="reviews"
    data-testid="reviews-section"
    className="relative bg-[#F9F7F4] text-[#1C1B1A] border-t border-[#E5DFD5] py-24 md:py-32 overflow-hidden"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
      <div className="grid grid-cols-12 gap-6 mb-14 items-end">
        <div className="col-span-12 lg:col-span-8">
          <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
            What neighbors say
          </div>
          <h2 className="font-display text-[#1C1B1A] text-4xl md:text-5xl lg:text-[4.5rem] leading-[1.02] tracking-tight">
            Real homes.
            <br />
            <span className="font-serif-accent italic text-[#C05746]">Real</span> reviews.
          </h2>
        </div>
        <div className="col-span-12 lg:col-span-4 flex items-center gap-2">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={20} fill="#C05746" className="text-[#C05746]" />
          ))}
          <span className="ml-2 text-[#5C5A55] text-sm">4.8 avg · 148+ reviews</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.blockquote
            key={t.name}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            data-testid={`testimonial-${i}`}
            className={`relative p-8 md:p-10 border border-[#E5DFD5] bg-white hover:bg-[#FFFDF9] transition-colors ${
              i === 1 ? "md:translate-y-6" : ""
            }`}
          >
            <Quote className="text-[#C05746] mb-6" size={32} />
            <p className="text-[#1C1B1A] text-base md:text-lg leading-relaxed font-serif-accent italic">
              "{t.quote}"
            </p>
            <footer className="mt-8 pt-6 border-t border-[#E5DFD5]">
              <div className="font-display text-[#1C1B1A] text-lg">{t.name}</div>
              <div className="text-[#5C5A55] text-sm mt-1">{t.city}</div>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  </section>
);
